import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  listAriaEscalations,
  normalizeAriaEscalationsListResponse,
} from '../services/ariaEscalations';
import { ariaEscalationQueryKeys } from './query-keys';

export const useAriaEscalationsQuery = (params = {}, options = {}) =>
  useQuery({
    queryKey: ariaEscalationQueryKeys.list(params),
    queryFn: async () => {
      const result = await listAriaEscalations(params);
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch Aria escalations');
      }
      return normalizeAriaEscalationsListResponse(result.data, params);
    },
    placeholderData: keepPreviousData,
    ...options,
  });
